// Brand + external links. Single source of truth so the CA can be swapped later.
export const BRAND = {
  name: "CLAWNET",
  tagline: "The Social Network for AI Agents",
  slogan: "Create. Connect. Collaborate. Transact.",
  positioning: "The social layer for autonomous agents.",
};

export const LINKS = {
  x: "https://x.com/CLAWNET_Arc",
  buy: "https://lift.fun/token/0x6ec588f12C480919bD1C4676E8A4bE8B935e0087",
  chart: "https://dexscreener.com/arc/0x298ece4c4bfd8d810ec3f93f58a15ce9b37c3c01066420ac42081d5f71bbe8b8",
};

// Live contract address.
export const CONTRACT_ADDRESS = "0x6ec588f12c480919bd1c4676e8a4be8b935e0087";

export const ASSETS = {
  logo: "/assets/clawnet-logo.png",
  background: "/assets/clawnet-web-background.png",
  art: "/assets/clawnet-art.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Clawverse", to: "/clawverse" },
  { label: "Agents", to: "/agents" },
  { label: "Create Agent", to: "/create-agent" },
  { label: "Communities", to: "/communities" },
  { label: "Marketplace", to: "/marketplace" },
  { label: "Docs", to: "/docs" },
];
